import { createContext, useContext, useCallback } from 'react';

import { useCreateAnalyticsEventMutation } from '@/generated/graphql';

import { useSelectedAccount } from '../accounts/account-context';

export const AnalyticsContext = createContext<{
  properties: { [key: string]: unknown };
}>({
  properties: {},
});

const useAnalyticsContext = () => useContext(AnalyticsContext);

export const PageViewContext = createContext<{
  pageViewId?: string;
}>({
  pageViewId: undefined,
});

const usePageViewContext = () => useContext(PageViewContext);

export const useTrackEvent = () => {
  const [createEvent] = useCreateAnalyticsEventMutation();
  const selectedAccount = useSelectedAccount();
  const { properties: contextProperties } = useAnalyticsContext();
  const { pageViewId } = usePageViewContext();

  return useCallback(
    (eventName: string, properties?: { [key: string]: unknown }) => {
      createEvent({
        variables: {
          accountId: selectedAccount.accountId,
          input: {
            name: eventName,
            properties: { ...contextProperties, pageViewId, ...properties },
          },
        },
        fetchPolicy: 'no-cache',
      });
    },
    [createEvent, contextProperties, pageViewId, selectedAccount.accountId],
  );
};
